import styled from "styled-components";
import { Accordion, AccordionSection } from "react-rainbow-components";

const Faq = ({FaqElems}) => {
  return (
    <Container>
      <h4 dir="rtl">پرسش های شما</h4>
      <div className="rainbow-m-around_xx-large">
        <Accordion>
          {
            FaqElems.map(elem => (
              <Question label={elem[0]}>
                {elem[1]}
              </Question>
            ))
          }
        </Accordion>
      </div>
    </Container>
  );
};

export default Faq;

const Container = styled.div`
  width: 1120px;
  border-radius: 10px;
  margin: 35px auto;

  @media (max-width: 900px) {
    width: 90vw;
  }
  @media (max-width: 1100px) {
    width: 98vw;
  }
`;

export const Question = styled(AccordionSection)`
  margin: 15px 0;
  box-shadow: 3px 6px 13px -10px rgba(0, 0, 0, 0.55);

  @media (max-width: 900px) {
    button {
      span {
        font-size: 17px;
        font-weight: 600;
      }
    }
  }

  span,
  section {
    text-align: right;
    direction: rtl;
  }

  section {
    font-size: 17px;
    font-weight: 300;
    line-height: 35px;
    color: #707070;
    padding: 10px 60px;
    border: none;

    @media (max-width: 900px){
      padding: 10px;
    }
  }

  span {
    font-size: 18px;
    font-weight: 500;
    color: #575656;
  }
  button {
    border: none;
    outline: none;
  }

  ul {
      list-style: none;
      li {
        margin: 10px 0;
        font-size: 17px;
        a {
          text-decoration: none;
          color: #616060;

          &:hover {
            color: #363636;
          }
        }
      }
    }
`;
